// hooks/useSpaceNavigate.js  (JS 버전)
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function useSpaceNavigate() {
    const nav = useNavigate();
    const { pathname, search } = useLocation();

    // space 라우트 안에 있으면 자동 주입
    const { space_uuid } = useParams();

    const navigate = (path, options) => {
        if (space_uuid) {
            nav(`/${space_uuid}${path}${search}`, options);
        } else {
            nav(path, options);
        }
    };

    return { navigate };
}
